// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"1faae430","598":"0e829382","703":"dedf365c"}[chunkId] + ".chunk.js";
};